import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FiGrid, FiImage, FiSend, FiCheck } from "react-icons/fi";
import { MAIN_URL, SHARE_URL } from "../../utils/appHost";
import "../style/AppSwitcher.css";

/**
 * Grid button that switches between Pic-Loud (galleries) and Pic-Loud Share (file transfers).
 * Rendered in HeaderAdmin on pic-loud.com and in ShareLayout on share.pic-loud.com.
 */
export default function AppSwitcher({ current }) {
  const { t } = useTranslation();

  const apps = [
    { key: "main", Icon: FiImage, href: `${MAIN_URL}/admin`, name: t("app_switcher.main_name"), desc: t("app_switcher.main_desc") },
    { key: "share", Icon: FiSend, href: `${SHARE_URL}/`, name: t("app_switcher.share_name"), desc: t("app_switcher.share_desc") },
  ];

  return (
    <Dropdown align="end">
      <Dropdown.Toggle as="div" className="d-flex align-items-center" style={{ cursor: "pointer" }} aria-label={t("app_switcher.title")}>
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#4b5563",
          }}
          title={t("app_switcher.title")}
        >
          <FiGrid size={16} />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="mt-2 shr-switcher-menu">
        <div className="shr-switcher-title">{t("app_switcher.title")}</div>
        {apps.map(({ key, Icon, href, name, desc }) => (
          <a key={key} href={href} className={`shr-switcher-item${current === key ? " current" : ""}`}>
            <span className="shr-switcher-icon"><Icon size={18} /></span>
            <span>
              <div className="shr-switcher-name">{name}</div>
              <div className="shr-switcher-desc">{desc}</div>
            </span>
            {current === key && <FiCheck className="shr-switcher-check" size={16} />}
          </a>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
